<template>
<div class="flex flex-col items-center justify-center">
	<OIcon v-if="type === 'ring'" name="spinner" class="animate-spin" :size/>

	<div v-else-if="type === 'writing'" class="lds-writing"/>

	<div v-else class="lds-ellipsis">
		<div/>
		<div/>
		<div/>
		<div/>
	</div>
	<div v-if="!hideLabel && !!label" class="text-body-lg lg:text-heading-xs mt-4 font-bold ">
		{{ label }}
	</div>
	<div v-if="texts.length" class="text-body-base relative mt-2 w-full text-neutral-600  lg:mt-3.5">
			&nbsp;
		<div
			v-for="(text, idx) in texts"
			:key="text"
			class="absolute inset-0 text-center transition-all"
			:class="[
				{
					' opacity-0': currentTextIndex !== idx,
					'translate-y-full': nextTextIndex === idx,
					'-translate-y-full': currentTextIndex !== idx && nextTextIndex !== idx,
				},
			]"
		>
			{{ text }}
		</div>
	</div>
</div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

const props = withDefaults(
	defineProps<{
		label?: string;
		hideLabel?: boolean;
		type?: 'ellipsis' | 'writing' | 'ring';
		size?: string;
		texts?: string[];
	}>(),
	{ label: '', type: 'ellipsis', texts: () => [] },
);

const currentTextIndex = ref(0);
const nextTextIndex = computed(() => (currentTextIndex.value + 1) % props.texts.length);
if (props.texts.length) {
	setInterval(() => {
		currentTextIndex.value = nextTextIndex.value;
	}, 3000);
}
</script>

<style lang="scss">
@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.lds-ellipsis {
	position: relative;
	display: inline-block;
	width: 64px;
	height: 64px;

	div {
		position: absolute;
		top: 27px;
		width: 11px;
		height: 11px;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);

		@apply bg-accent;

		border-radius: 50%;

		&:nth-child(1) {
			left: 6px;
			animation: lds-ellipsis1 0.6s infinite;
		}

		&:nth-child(2) {
			left: 6px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-child(3) {
			left: 26px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-child(4) {
			left: 45px;
			animation: lds-ellipsis3 0.6s infinite;
		}
	}
}

@keyframes lds-ellipsis1 {
	0% {
		transform: scale(0);
	}

	100% {
		transform: scale(1);
	}
}

@keyframes lds-ellipsis3 {
	0% {
		transform: scale(1);
	}

	100% {
		transform: scale(0);
	}
}

@keyframes lds-ellipsis2 {
	0% {
		transform: translate(0, 0);
	}

	100% {
		transform: translate(19px, 0);
	}
}

.lds-writing {
	position: relative;
	width: 4px;
	height: 4px;
	border-radius: 5px;
	background-color: #1A1A1A;
	color: #1A1A1A;
	animation: lds-writing 1s infinite linear alternate;
	animation-delay: 0.5s;
}
.lds-writing::before, .lds-writing::after {
	content: "";
	display: inline-block;
	position: absolute;
	top: 0;
}
.lds-writing::before {
	left: -8px;
	width: 4px;
	height: 4px;
	border-radius: 5px;
	background-color: #1A1A1A;
	color: #1A1A1A;
	animation: lds-writing 1s infinite alternate;
	animation-delay: 0s;
}
.lds-writing::after {
	left: 8px;
	width: 4px;
	height: 4px;
	border-radius: 5px;
	background-color: #1A1A1A;
	color: #1A1A1A;
	animation: lds-writing 1s infinite alternate;
	animation-delay: 1s;
}

@keyframes lds-writing {
	0% {
		background-color: #1A1A1A;
	}
	50%, 100% {
		background-color: #E6E6E6;
	}
}
</style>
